import Container from "react-bootstrap/esm/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import Slider from "react-slick";
import PrevArrow from "../../../UI/CustomButton/Arrows/PrevArrow";
import RightArrow from "../../../UI/CustomButton/Arrows/RightArrow";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Carousel.css";

const Carousel = () => {
  const handleAboutClick = () => {
    var elmntToView = document.getElementById("about");
    elmntToView.scrollIntoView();
  };
  const handleProductClick = () => {
    var elmntToView = document.getElementById("products");
    elmntToView.scrollIntoView();
  };
  const settings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow color={"#ffffff"} />,
    nextArrow: <RightArrow color={"#ffffff"} />,
    // autoplay: true,
    adaptiveHeight: true,
  };
  return (
    <>
      <Container fluid className="p-0 m-0 hero_carousel_root" id="home">
        <Slider {...settings} className="slider_container_root p-0 m-0">
          <div className="slide_container slide_container-1">
            <div className="hero_intro_wrapper w-50">
              <div className="hero_intro_title">
                <h2>
                  Customer <br />
                  First
                </h2>
              </div>
              <div className="hero_intro_subsection">
                <p>
                  Experience the ultimate in vehicle care with our extensive
                  selection of authentic OEM and aftermarket spares for all
                  vehicle types.
                </p>
              </div>
              <div className="hero_button_wrapper">
                <button className="hero_button" onClick={handleProductClick}>
                  Our Products
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="nav_arrowRight"
                  />
                </button>
                <button className="hero_button" onClick={handleAboutClick}>
                  More About us
                </button>
              </div>
            </div>
          </div>
          <div className="slide_container slide_container-2">
            <div className="hero_intro_wrapper w-50">
              <div className="hero_intro_title">
                <h2>
                  Excellence <br />
                  in service
                </h2>
              </div>
              <div className="hero_intro_subsection">
                <p>
                  Our direct procurement policy guarantees the lowest rates
                  without compromising on quality, ensuring you receive the best
                  value for your money.
                </p>
              </div>
              <div className="hero_button_wrapper">
                <button className="hero_button" onClick={handleProductClick}>
                  Our Products
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="nav_arrowRight"
                  />
                </button>
                <button className="hero_button" onClick={handleAboutClick}>
                  More About us
                </button>
              </div>
            </div>
          </div>
          <div className="slide_container slide_container-3">
            <div className="hero_intro_wrapper w-50">
              <div className="hero_intro_title">
                <h2>
                  Global <br />
                  Outreach
                </h2>
              </div>
              <div className="hero_intro_subsection">
                <p>
                  Fast and reliable delivery service backed by exceptional
                  customer service and support.
                </p>
              </div>
              <div className="hero_button_wrapper">
                <button className="hero_button" onClick={handleProductClick}>
                  Our Products
                  <FontAwesomeIcon
                    icon={faArrowRight}
                    className="nav_arrowRight"
                  />
                </button>
                <button className="hero_button" onClick={handleAboutClick}>
                  More About us
                </button>
              </div>
            </div>
          </div>
        </Slider>
      </Container>
    </>
  );
};

export default Carousel;
